import { useEffect, useState } from 'react';

import ghostImgUrl from './whiteGhost.png';
import { Box } from '@mui/system';

function useGhostMover(initialDirection: { dx: number; dy: number }) {
  const [pos, setPos] = useState(() => ({
    x: Math.random() * (window.innerWidth - 120),
    y: Math.random() * (window.innerHeight - 120),
  }));
  const [direction, setDirection] = useState(initialDirection);

  useEffect(() => {
    let frame: number;
    function animate() {
      setPos((prev) => {
        let { x, y } = prev;
        let { dx, dy } = direction;
        x += dx;
        y += dy;
        if (x < 0 || x > window.innerWidth - 120) dx = -dx;
        if (y < 0 || y > window.innerHeight - 120) dy = -dy;
        setDirection({ dx, dy });
        return {
          x: Math.max(0, Math.min(x, window.innerWidth - 120)),
          y: Math.max(0, Math.min(y, window.innerHeight - 120)),
        };
      });
      frame = requestAnimationFrame(animate);
    }
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [direction]);

  return pos;
}

export const GhostAnimation = () => {
  const pos1 = useGhostMover({ dx: 2, dy: 1.5 });
  const pos2 = useGhostMover({ dx: -2.5, dy: 2 });
  const pos3 = useGhostMover({ dx: 1.2, dy: -2.2 });
  const pos4 = useGhostMover({ dx: -1.7, dy: -1 });
  const pos5 = useGhostMover({ dx: -1.5, dy: -1 });

  return (
    <>
      <Box
        component='img'
        key={0}
        src={ghostImgUrl}
        alt='Spooky Ghost 1'
        sx={{
          left: pos1.x,
          top: pos1.y,
          ...ghostStyles,
        }}
      />
      <Box
        component='img'
        alt='Spooky Ghost 2'
        key={1}
        src={ghostImgUrl}
        sx={{
          left: pos2.x,
          top: pos2.y,
          ...ghostStyles,
        }}
      />
      <Box
        component='img'
        key={2}
        src={ghostImgUrl}
        alt='Spooky Ghost 3'
        sx={{
          left: pos3.x,
          top: pos3.y,
          ...ghostStyles,
        }}
      />
      <Box
        component='img'
        key={3}
        src={ghostImgUrl}
        alt='Spooky Ghost 4'
        sx={{
          left: pos4.x,
          top: pos4.y,
          ...ghostStyles,
        }}
      />
      <Box
        component='img'
        key={4}
        src={ghostImgUrl}
        alt='Spooky Ghost 5'
        sx={{
          left: pos5.x,
          top: pos5.y,
          ...ghostStyles,
        }}
      />
    </>
  );
};

const ghostStyles = {
  position: 'fixed',
  width: 120,
  height: 120,
  opacity: 0.4,
  pointerEvents: 'none',
  zIndex: 9999,
  transition: 'filter 0.2s',
  filter: 'drop-shadow(0 0 16px orange)',
};
